import React from 'react';
import errorImg from "../images/error-page.png"

export default function NotFound() {
  return (
    <div className='w-100 px-2 mt-sm-2 mt-5 d-flex flex-column justify-content-center align-items-center not-found'>
      <img src={errorImg} alt="404 Not Found" width="75" className='mb-2' />
      <h5 className='text-center'>404 - Page Not Found</h5>
      <p className='text-center'>We're sorry, the page you requested could not be found.</p>
    </div>
  )
}
